import { Button } from "react-bootstrap";
import { useGeneralAppStore } from "../../../../../store/generalAppStore";
import "./style.css"
import IconButton from "../../../../../components/IconsButton";

const Opcion = (props) => {
    const {
        icono = null,
        label,
        modal,
        anular = false,
        type = null,
        onClick,
        variant = "primary",
        disabled,
    } = props;
    const { handlerModal } = useGeneralAppStore()

    return (
        <div
            className={`d-flex   ${type == "horizontal" ? "flex-row justify-content-start ps-2" : "flex-column justify-content-center"}  gap-2 align-items-center rounded  ${disabled ? 'Disabled' : label} ${anular ? "opcion-anular" : "opcion"} `}
            style={{ border: "1px solid black", cursor: !disabled ? "pointer" : "default", width: type == "horizontal" ? "150px" : "100px", height: type == "horizontal" ? "40px" : "80px" }}
            onClick={() => {
                if (!disabled) {
                    handlerModal({ modal: true, modalName: modal })
                }
            }
            }
        >
            <IconButton label={label} />
            {label}
        </div>
    );
};

export default Opcion;
